import React from 'react';

import { AddContact } from '@components/utilities/Contact/AddContact';

export const AddShipper: React.FC = () => (
  <AddContact contactType="shipper" ownedContactType="pickup_address" />
);
